"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tappableCardClasses = exports.TappableCardButton = void 0;
// istanbul ignore file: doesn't hold any logic
const TappableCard_1 = __importDefault(require("./TappableCard"));
var styles_1 = require("./styles");
Object.defineProperty(exports, "TappableCardButton", { enumerable: true, get: function () { return styles_1.TappableCardButton; } });
Object.defineProperty(exports, "tappableCardClasses", { enumerable: true, get: function () { return styles_1.classes; } });
exports.default = TappableCard_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGFwcGFibGUtY2FyZC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSwrQ0FBK0M7QUFDL0Msa0VBQTBDO0FBSTFDLG1DQUE4RTtBQUFyRSw0R0FBQSxrQkFBa0IsT0FBQTtBQUFFLDZHQUFBLE9BQU8sT0FBdUI7QUFFM0Qsa0JBQWUsc0JBQVksQ0FBQyJ9